export const routes = {
    "/:taskId/bbvReport": {
        title: "BBV Report"
    },
};
